import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Augmented Reality Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='Augmented Reality Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'Augmented Reality Development'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='Next-Gen Augmented Reality Solutions'
          subtitle='Blending Digital with Physical Worlds'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we specialize in building immersive Augmented Reality (AR) experiences that redefine user engagement and brand storytelling. Our AR development services bridge the digital and real world—bringing objects, information, and interactions to life in real time.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          Whether it's product visualization, AR games, virtual try-ons, or enterprise training, we use cutting-edge AR toolkits like ARKit, ARCore, Unity, and WebAR to deliver innovative, cross-platform solutions.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Services Section */}
      <Div className="container">
        <SectionHeading
          title='Our Augmented Reality Services'
          subtitle='Interactive, Immersive, and Impactful AR Experiences'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='AR App Development'
              subtitle='Custom AR apps for Android, iOS, and smart glasses using ARKit and ARCore.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Web-Based AR (WebAR)'
              subtitle='Browser-based AR experiences—no downloads required.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='AR for E-Commerce'
              subtitle='Virtual product try-ons, 3D previews, and interactive shopping experiences.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='AR Game Development'
              subtitle='Engaging and interactive games using real-world environments and objects.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='Enterprise AR Solutions'
              subtitle='AR tools for remote assistance, field service, training, and collaboration.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='Marker-based & Markerless AR'
              subtitle='Custom experiences using image targets or spatial/environmental tracking.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries Leveraging AR'
          subtitle='Revolutionizing User Experiences Across Sectors'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/cart-icon.svg'
              title='Retail & E-Commerce'
              subtitle='Virtual product trials, store navigation, and immersive brand interaction.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/education-icon.svg'
              title='Education'
              subtitle='Augmented textbooks, anatomy models, and AR-based remote learning tools.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/healthcare-icon.svg'
              title='Healthcare'
              subtitle='AR-assisted surgery, diagnostics, and medical training simulations.'
            />
          </Div>
        </Div>
        <Div className="row mt-lg-5" >
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/house-icon.svg'
              title='Real Estate'
              subtitle='Property walkthroughs, interior visualization, and architectural AR renders.'
            />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/media-icon.svg'
              title='Marketing & Advertising'
              subtitle='Interactive AR campaigns that engage and delight consumers.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
